import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Popover() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="outlined"
        style={{
          color: "white",
          fontSize: "20px",
          border: "0.4rem solid #227093",
          textShadow: "2px 2px 2px black",
        }}
        onClick={handleClickOpen}
      >
        Our Tokenomics
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {
            <p
              style={{
                textAlign: "center",
                fontSize: "26px",
              }}
            >
              Total Supply 1 Quadrillion Just Smile
            </p>
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "black",fontSize: "18px" }}>
            Community driven & Fair launch. Dev burned 90% supply and add 20%
            to LP on pancakeswap. Burn 100% LP tokens and Renounce Ownership.
            Funds 100% SAFU
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}